import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useBox } from "../../Finanzas/Helper/useBox";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FiltroCotizacionesServicio } from "./FiltroCotizacionesServicio";
import { CotizacionesServicioTabla } from "./CotizacionesServicioTabla";

const hoy = new Date();
const PRIMER_DIA_MES = new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().substring(0, 10);
const ULTIMO_DIA_MES = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0).toISOString().substring(0, 10);

// Pantalla de Cotizaciones de Servicio — historial con filtro y alta rápida, mismo patrón
// visual que los reportes CRM (header + tabla con thead texturizado). Conectada a
// CotizacionesCRM/ListadoCotizaciones y CotizacionesCRM/EliminarCotizaciones. Por defecto
// carga el mes actual completo; el backend exige fechainicio/fechafin/adr/sucursal no vacíos.
export const CRM_CotizacionesServicio = () => {
  const history = useHistory();

  const [boxstate, setBoxState] = useBox({
    fechaInicio: PRIMER_DIA_MES,
    fechaFin: ULTIMO_DIA_MES,
    pv: { adr: [], sucursal: [] },
  });

  const [listado, setListado] = useState([]);
  const [permisos, setPermisos] = useState();
  const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });

  const puedeEditar = ["VESC", "GESU", "UREG", "ADCS", "REWR", "UCBA", "UCLD", "UCLR", "UCLS"].includes(permisos?.usuariorol);
  const puedeEliminar = ["VESC", "GESU", "UREG", "ADCS", "REWR", "UCBA", "UCLD", "UCLR", "UCLS"].includes(permisos?.usuariorol);

  const cargarReporte = (filtro) => {
    const f = filtro || { fechaInicio: boxstate.fechaInicio, fechaFin: boxstate.fechaFin };
    const adr = (boxstate.pv?.adr || []).map((a) => a.idadr).join(",") || "0";
    const sucursal = (boxstate.pv?.sucursal || []).map((s) => s.idsucursal).join(",") || "0";

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`CotizacionesCRM/ListadoCotizaciones?fechainicio=${f.fechaInicio || PRIMER_DIA_MES}&fechafin=${f.fechaFin || ULTIMO_DIA_MES}&adr=${adr}&sucursal=${sucursal}`)
      .then((result) => {
        setListado(Array.isArray(result?.cotizaciones) ? result.cotizaciones : []);
        setPermisos(result?.permisos);
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("COTIZACIONES DE SERVICIO", JSON.stringify(error), "error");
      });
  };

  // Descarga el PDF de la cotización — la plantilla ("dron" | "riego" | "servicio") la elige el
  // usuario desde el menú del botón PDF en la tabla (ver CotizacionesServicioTabla).
  const onGeneraPDF = (folio, plantilla) => {
    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`CotizacionesCRM/ImprimirPDF?folio=${folio}&plantilla=${plantilla}`)
      .then((result) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        const linkSource = `data:application/pdf;base64,${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("COTIZACIONES DE SERVICIO", JSON.stringify(error), "error");
      });
  };

  const onEliminar = (folio) => {
    if (!puedeEliminar) return;

    Swal.fire({
      title: "¿Eliminar cotización?",
      text: `Se eliminará la cotización ${folio}. Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      setLoader((prev) => ({ ...prev, mostrar: true }));
      request
        .get(`CotizacionesCRM/EliminarCotizaciones?folio=${folio}`)
        .then(() => {
          setLoader((prev) => ({ ...prev, mostrar: false }));
          Swal.fire("COTIZACIONES DE SERVICIO", "Cotización eliminada correctamente", "success");
          cargarReporte();
        })
        .catch((error) => {
          setLoader((prev) => ({ ...prev, mostrar: false }));
          Swal.fire("COTIZACIONES DE SERVICIO", JSON.stringify(error), "error");
        });
    });
  };

  useEffect(() => {
    cargarReporte();
  }, []);

  return (
    <div className="crm-main-screen">
      <LoaderScreen loader={loader} />
      <div className="crm-body">
        <div className="crm-page rca-screen">
          <div className="crm-module">
            <div className="crm-module-head">
              <div className="crm-head-grid">
                <div className="crm-head-left">
                  <button className="crm-btn-regresar" onClick={() => history.push("/DashClientes/Main")}>
                    <ArrowBackIcon /> Regresar
                  </button>
                  <FiltroCotizacionesServicio onCargar={cargarReporte} boxState={boxstate} onBoxChange={setBoxState} permisos={permisos} />
                </div>
                <div className="crm-head-center">
                  <p className="crm-module-subtitle">Cotizaciones de Servicio</p>
                  <h1 className="crm-module-title">COTIZACIONES DE SERVICIO</h1>
                </div>
                <div className="crm-head-right">
                  {puedeEditar && (
                    <button
                      className="crmcs-btn-agregar"
                      onClick={() => history.push("/DashClientes/CotizacionesServicio/Agregar")}
                    >
                      <AddCircleOutlineIcon /> Agregar cotización
                    </button>
                  )}
                </div>
              </div>
              <div className="crm-head-divider">
                <div className="crm-head-divider-dot" />
              </div>
            </div>

            <div className="crm-home-wrapper rca-wrapper scroll">
              <CotizacionesServicioTabla
                listado={listado}
                onGeneraPDF={onGeneraPDF}
                onEditar={puedeEditar ? (folio) => history.push(`/DashClientes/CotizacionesServicio/Agregar?folio=${folio}`) : undefined}
                onEliminar={puedeEliminar ? onEliminar : undefined}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
